import React from 'react'
import { useIntl } from 'react-intl'
import ConfirmModal from '../../../../components/modals/ConfirmModal'
import type { ConfirmModalProps } from '../../../../components/modals/ConfirmModal'

export type InviteConfirmModalProps = {
	confirmButtonText?: string
} & Omit<ConfirmModalProps, 'title' | 'button'>

const InviteConfirmModal = ({
	confirmButtonText,
	...rest
}: InviteConfirmModalProps) => {
	const { formatMessage } = useIntl()
	return (
		<ConfirmModal
			title={formatMessage({ id: 'invites.econsent_title' })}
			button={{
				title:
					confirmButtonText ||
					formatMessage({ id: 'invites.send_invite' }),
				loading: false,
				disabled: false,
			}}
			disclaimer={formatMessage({
				id: 'invites.econsent_disclaimer',
			})}
			{...rest}
		/>
	)
}

export default InviteConfirmModal
